import React from 'react';

export const NotFound = () => (
  <div>404 NOT FOUND</div>
);
